/* Base
========================================================================== */

jQuery(document).ready(function ($) {

  // Slider Txt
  if ($(".slider-txt").length > 0) {
    $(".slider-txt").owlCarousel({
      loop: true,
      nav: true,
      autoplay: false,
      mouseDrag: true,
      touchDrag: true,
      items: 1,
    })
  }

  // Slider Classic
  if ($(".slider-classic").length > 0) {
    $(".slider-classic").owlCarousel({
      loop: true,
      nav: true,
      autoplay: false,
      mouseDrag: true,
      touchDrag: true,
      items: 1,
    });
    
  }
  
  // Slider Classic
  if ($(".type-jobs .quote").length > 0) {
    $(".type-jobs .quote").owlCarousel({
      loop: true,
      nav: false,
      autoplay: true,
      mouseDrag: true,
      touchDrag: true,
      items: 1,
    });
  }
  // Slider Classic
  if ($(".section-quotes .owl-carousel").length > 0) {
    $(".section-quotes .owl-carousel").owlCarousel({
      loop: true,
      nav: false,
      autoplay: true,
      mouseDrag: true,
      touchDrag: true,
      items: 1,
    });
  }

  if ($(".page-template-homepage .partners ul").length > 0) {
    $(".page-template-homepage .partners ul").owlCarousel({
      loop: true,
      nav: false,
      dots: false,
      autoplay: false,
      mouseDrag: true,
      touchDrag: true,
      responsive : {
      	0 : {
      		items: 2
      	},
      	540 : {
      		items: 3
      	},
      	992 : {
      		items: 5
      	}
      }
    });
  }


  // Slider Classic
  if ($(".page-template-homepage .the-carousel").length > 0) {
    $(".page-template-homepage .the-carousel").owlCarousel({
      loop: false,
      nav: true,
      dots: true,
      dotsData: true,
      autoplay: false,
      mouseDrag: true,
      touchDrag: true,
      items: 1,
      animateOut: 'fadeOut',
      lazyLoad: frontendajax.gblmaster_lazy_load || false,
    });
  }

  $('.page-template-homepage .the-carousel .owl-dot').click(function () {
    $(".page-template-homepage .the-carousel").trigger('to.owl.carousel', [$(this).index(), 1000]);
  })

  if ($(".page-template-about .awards ul").length > 0) {
    $(".page-template-about .awards ul").owlCarousel({
      loop: false,
      nav: false,
      dots: false,
      autoplay: false,
      mouseDrag: true,
      touchDrag: true,
      responsive : {
        0 : {
          items: 2
        },
        540 : {
          items: 3
        },
        // 992 : {
        //   items: 5
        // }
      }
    });
  }

})
